@if (data().items && data().items.length) {
  <section class="gallery-layout gallery-layout-1">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-xs-5">
          @if (items()[0] && items()[0]!.url) {
            <figure (click)="onNavigate(items()[0]!.url)" class="figure">
              @if (items()[0]!.image; as image) {
                <app-image [image]="image" [size]="{ dw: 500, dh: 729, mh: 209 }" class="img" />
              }
              <figcaption>
                <app-title [titles]="[subtitle().previous]" />
                @if (items()[0]!.url; as url) {
                  <a [routerLink]="url" class="link">
                    @if (items()[0]!.title; as title) {
                      <app-title [titles]="[title]" class="title" />
                    }
                  </a>
                }
              </figcaption>
            </figure>
          }
        </div>
        <div class="col-lg-5 col-lg-offset-2 col-xs-offset-2 col-xs-5">
          @if (items()[1] && items()[1]!.url) {
            <figure (click)="onNavigate(items()[1]!.url)" class="figure">
              @if (items()[1]!.image; as image) {
                <app-image [image]="image" [size]="{ dw: 500, dh: 729, mh: 209 }" class="img" />
              }
              <figcaption>
                <app-title [titles]="[subtitle().next]" />
                <a [routerLink]="items()[1]!.url" class="link">
                  @if (items()[1]!.title; as title) {
                    <app-title [titles]="[title]" class="title" />
                  }
                </a>
              </figcaption>
            </figure>
          }
        </div>
      </div>
    </div>
  </section>
}
